import React from "react";
import AggregatorResult from "./AggregatorResult";

const AggregatorFailed = () => {
  return <AggregatorResult variant="failed" />;
};

export default AggregatorFailed;
